import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@models/core/model-factory';
import { ChangeRequestTemplate } from '@models/change-requests/change-request-template.model';
import { Injectable } from '@angular/core';
import { Employee } from '@models/employee/employee.model';
import { ChangeRequest } from '@models/change-requests/change-request.model';

@Injectable()
export class ChangeRequestsResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'changeRequest',
            production: {
                find: (id: number) => {
                    return ChangeRequest.with([
                        'fieldValues.field',
                        'cancelledBy',
                        'requestedBy',
                        'subject',
                        'template',
                        'approvalInstance',
                        'approvalInstance.forcedBy',
                        'approvalInstance.steps',
                        'approvalInstance.steps.employee',
                    ]).find(id);
                },
            },
        },
        {
            className: 'changeRequestTemplate',
            production: {
                find: (id: number) => {
                    return ChangeRequestTemplate.param('company', this.auth.company.id)
                        .with(['approvalWorkflow', 'approvalWorkflow.steps.employee', 'fields', 'roles'])
                        .find(id);
                },
            },
        },
        {
            className: 'employee',
            production: {
                find: (id: number) => {
                    return Employee.param('company', this.companyId).find(id);
                },
            },
        },
    ]);
}
